import { render, staticRenderFns } from "./IdentityNumberZa.vue?vue&type=template&id=0c2e1784&"
import script from "./IdentityNumberZa.vue?vue&type=script&lang=js&"
export * from "./IdentityNumberZa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports